import { PageMode } from '@/main/utils/pageMode';
import { Row, Table, Cell } from '@/main/utils/table';

import { JFND_ZPRACREZIM_PZN } from '../../constants';

export const props = {
	mode: null as PageMode | null,
	filter: {
		ZakazkaId: null as number | null,
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		NabidkaPrp: null as boolean | null,
		ZakaznikId: null as number | null,
		VozidloId: null as number | null,
	},
	afterRowSelection: () => {},
};

export const dropdownList = {
	VyrobekvozOzn: [],
	JfndZpracrezimPzn: [],
	SkladOzn: [],
};

export const filter = {
	SkladOzn: null as number | null,
	ZakazkaId: null as number | null,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	JfndZpracrezimPzn: JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ as JFND_ZPRACREZIM_PZN,
	PracovnikId: null as number | null,
	ZakazkoKratitPrp: true,
	// #region data from filter props
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as string | null,
	NabidkaPrp: null as boolean | null,
	ZakaznikId: null as number | null,
};

export type Filter = typeof filter;

export const localState = {
	cekatNaObj: false,
	multipleSelection: [] as Row[],
	nahradyTable: new Table(),
	selectedNdRow: null as Cell[] | null,
	odpisResult: null as string[] | null,
	editFormName: null as string | null,
	objednavkaOptins: { mioPzn: -1, ZakazkaId: null as number | null, kratitPrp: false },
	dialog: {
		visible: false,
		title: 'cmdPrevod',
		ZakazkaId: null as number | null,
		ZakazkaIdText: null as string | null,
		ZakazkaIdNr: null as number | null,
	},
};
